import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AuditConnectionsMobile from "../mobile/audit/AuditConnectionsMobile";
import AuditConnexions from "./AuditConnexions";
export default function ResponsiveAuditConnections(props) { return useIsMobile() ? <AuditConnectionsMobile {...props} /> : <AuditConnexions {...props} />; }
